<auth-layout title="Verify Your Email ID" type="SIGNUP" subTitile="Please enter the 4-digit verification code that was sent to retailer email. The code
is valid
for 3
minute.">

    <form [formGroup]="otpForm" style="position: relative;
    max-width: 226px;">
        <div class=" otp">
            <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:4}"></ng-otp-input>
        </div>
        <div style="text-align: right;">
            <strong style="color: #c01e2f;">{{remainingTime}}</strong>
        </div>

        <div class="vca d-flex justify-content-between mt-3">
            <div class="vca">
                <span class="o-f" (click)="navigateToResetPassword()">Verify</span>
            </div>

            <div class=" forcenter">
                <a class="res-otp" (click)="resendOtp()" *ngIf="isExpire; else notExpired">Resend OTP</a>
                <ng-template #notExpired><a style="color: gray; cursor: none;">Resend OTP</a></ng-template>
                <!-- <a class="res-otp" (click)="resendOtp()" *ngIf="isExpire">Resend OTP</a>
            <a class="res-otp" *ngIf="!isExpire" style="color: gray;cursor: none;">Resend OTP</a> -->
                <!-- <p class="mt-10">{{time == '1.59' || time == '0.59' ? '' : time }}</p> -->
            </div>
        </div>

    </form>

</auth-layout>